import { render, staticRenderFns } from "./perfekt-svaga-verb.vue?vue&type=template&id=5c7bc1ba&scoped=true"
import script from "./perfekt-svaga-verb.vue?vue&type=script&lang=js"
export * from "./perfekt-svaga-verb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7bc1ba",
  null
  
)

export default component.exports